export const ourBrands = [
    {
      id: 1,
      name: "lumiarq",
      linkImg: '/images/brands/la.png',
    },
    {
      id: 2,
      name: "maxled",
      linkImg: '/images/brands/maxled.png',
    },
    {
      id: 3,
      name: "reletric",
      linkImg: '/images/brands/reletric.png',
    },
    {
      id: 4,
      name: "westinghouse",
      linkImg: '/images/brands/westinghouse.png',
    },
    {
      id: 5,
      name: "rdesign",
      linkImg: '/images/brands/rdesign.png',
    },
    {
      id: 6,
      name: "livolo",
      linkImg: '/images/brands/livolo.jpg',
    },
    {
      id: 7,
      name: "suntree",
      linkImg: '/images/brands/suntree.png',
    }, 
    {
      id: 8,
      name: "gewiss",
      linkImg: '/images/brands/gewiss.png',
    }, 
    {
      id: 9,
      name: "linergy",
      linkImg: '/images/brands/linergy.png',
    }, 
    {
      id: 10,
      name: "obo",
      linkImg: '/images/brands/obo.png',
    },
    {
      id: 11,
      name: "quiterios",
      linkImg: '/images/brands/quiterios.png',
    },
    {
      id: 12,
      name: "nexans",
      linkImg: '/images/brands/nexans.jpg',
    },
    {
      id: 13,
      name: "wago",
      linkImg: '/images/brands/wago.png',
    },
    {
      id: 14,
      name: "hikvision",
      linkImg: '/images/brands/hikvision.png',
    },
    {
      id: 15,
      name: "alcobre",
      linkImg: '/images/brands/alcobre.png',
    },
    {
      id: 16,
      name: "dahua",
      linkImg: '/images/brands/dahua.png',
    },
    {
      id: 17,
      name: "efapel",
      linkImg: '/images/brands/efapel.png',
    },
    {
      id: 18,
      name: "schneider",
      linkImg: '/images/brands/schneider.png',
    },
    {
      id: 19,
      name: "himel",
      linkImg: '/images/brands/himel.png',
    },
]